(() => {
  const markHorizontalRow = (wrapper) => {
    if (!wrapper) return;

    const candidates = Array.from(wrapper.querySelectorAll('ul, ol, div'));
    let best = null;
    let bestScore = 0;

    for (const candidate of candidates) {
      const children = Array.from(candidate.children || []);
      if (children.length < 2) continue;

      const visualChildren = children.filter((child) =>
        child.querySelector?.('img, picture, a, button, input, label')
      ).length;

      const score = visualChildren * 10 + children.length;
      if (visualChildren >= 2 && score > bestScore) {
        best = candidate;
        bestScore = score;
      }
    }

    if (best) {
      wrapper.querySelectorAll('.vf-swatches-horizontal-row').forEach((node) => {
        if (node !== best) node.classList.remove('vf-swatches-horizontal-row');
      });
      best.classList.add('vf-swatches-horizontal-row');
    }
  };

  const init = () => {
    document.querySelectorAll('.vf-lens-swatches-scroll').forEach((wrapper) => {
      markHorizontalRow(wrapper);

      if (wrapper.dataset.vfHorizontalObserver === 'true') return;
      wrapper.dataset.vfHorizontalObserver = 'true';

      const observer = new MutationObserver(() => markHorizontalRow(wrapper));
      observer.observe(wrapper, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();